module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }